import {
  goalInboxID,
  goalsArchivedSectionID,
  goalsCompletedSectionID,
  ID,
  lifeAreaOtherID,
  rootId,
  TaskListItemTypes,
} from '@griply/types';

import { GoalLinkRow } from './resolve-moved-goal-links';

export type GoalRowParent = {
  id: ID;
  type: TaskListItemTypes;
};

export type ResolveGoalRowLinkOptions = {
  parent?: GoalRowParent;
  // Elsewhere a LifeArea-typed node is a quarter or static section, carrying no link.
  sectionsAreLifeAreas?: boolean;
  // The link a root row hangs under, for a list rooted in one goal or life area.
  rootLink?: GoalLinkRow;
};

const linklessSectionIds = new Set<ID>([
  rootId,
  goalInboxID,
  lifeAreaOtherID,
  goalsArchivedSectionID,
  goalsCompletedSectionID,
]);

// The link a row sits under; undefined means none, so the caller keeps its own fallback.
export const resolveGoalRowLink = ({
  parent,
  sectionsAreLifeAreas,
  rootLink,
}: ResolveGoalRowLinkOptions): GoalLinkRow | undefined => {
  if (!parent || parent.id === rootId) {
    return rootLink;
  }

  if (parent.type === TaskListItemTypes.Goal) {
    return { goalId: parent.id };
  }

  if (
    sectionsAreLifeAreas &&
    parent.type === TaskListItemTypes.LifeArea &&
    !linklessSectionIds.has(parent.id)
  ) {
    return { lifeAreaId: parent.id };
  }

  return undefined;
};
